// hooks
import { useSelectedPage } from "../../../../Hooks/Display/usePages";
import { usePropsStoreValue } from "../../../../Hooks/PropStore/usePropsStore";
import { getDatalakeImageUrl } from "../../../Helpers/DateLakeStorage";
import useComponentPropertiesContext, { useValidation } from "../../../../Hooks/Display/useComponentProperties";
import { useTranslation } from "react-i18next";

function RuntimeConfigPageHeading({ handleSave }) {

    const selectedPage = useSelectedPage();

    const entityLabel = usePropsStoreValue("entityLabel");
    const publishApp = usePropsStoreValue("publishApp");
    const [componentState, componentDispatch] = useComponentPropertiesContext();
    const [validation] = useValidation();

    const { t } = useTranslation("display/component_toolbar", { useSuspense: false });

    // states
    const publishMessage = false;

    // functions
    async function handlePublish() {
        try {
            componentDispatch({
                type: "TOGGLE_PUBLISHING"
            })
            await handleSave();
            await publishApp();
        } catch (error) {
            console.log(error);
        } finally {
            componentDispatch({
                type: "TOGGLE_PUBLISHING"
            })
        }
    }

    return (
        <div className="border-bottom edit" >
            <div className="row my-1 align-items-center">
                <div className="col flex-grow-1">
                    {t("edit_label")}{" "}
                    <span className="mx-1 font-weight-bolder">{entityLabel}</span>{" "}
                    -{" "}
                    <span className="mx-1 font-weight-bolder">{selectedPage.pageName}</span>{" "}
                    {t("page_label")}
                </div>
                {publishMessage && (
                    <div className="text-error col pe-0">{publishMessage}</div>
                )}
                <div className="col-5 text-end">
                    {componentState.isPublishing && (
                        <span className="ms-2">
                            <img
                                alt="loader"
                                width="30px"
                                src={`${getDatalakeImageUrl("loaders/SpinLoader.gif")}`}
                            />
                        </span>
                    )}
                    <button
                        disabled={componentState.isPublishing || validation.hasErrors}
                        title="Publish"
                        onClick={handlePublish}
                        type="button"
                        className="btn btn-outline-primary me-2 mb-1"
                    >
                        <i className="mx-2 fas fa-rocket"></i>{t("buttons.update_page")}
                    </button>
                </div>
            </div>
        </div>
    )
}

export default RuntimeConfigPageHeading;